import Store from "../store";
import { API } from "redux/api";
import { encryptJson, encryptJsonWithStaffId } from "../../util/react-ec-utils"
import { filterNullAndEmptyStrings } from "../../util/filterObject";

export function fetchOutlets(merchantId:any) {
  const locationId = Store.getState()?.auth?.selectedBranch?.id || Store.getState()?.auth?.credentials?.locationId || "";
  return API({
    method: "post",
    url: "/merchants/deviceRegister",
    data: {
      merchantId: merchantId,
      locationId: locationId,
      deviceIdentifier: "",
      deviceType: "",
    },
  })
}


//Create Employee
export function createEmployee(details:any) {
  const staffId = Store.getState()?.auth?.credentials?.id;
  const data = encryptJsonWithStaffId(details, staffId);
  return API({
    method: "post",
    url: `/merchants/staffs/add`,
    data: {data},
  })
}

//Get Employee
export function getEmployeeDetails(locationId:any) {
  const staffId = Store.getState()?.auth?.credentials?.id;
  const payload = {"locationId":locationId, "staffId": staffId}
  const encPayload = encryptJson(payload);
  return API({
    method: "post",
    url: `/merchants/staffs`,
    data:{"data":encPayload},
  },)
}

//Get Employee By ID
export function getEmployeeById(staffId:any) {
  const merchantId = Store.getState()?.auth?.credentials?.merchantId;

  const reqPayload = {merchantId:merchantId,staffId:staffId}
  const data = encryptJson(reqPayload);
  return API({
    method: 'post',
    url: `/merchants/staff/details`,
    data:{data},
  })
}

//Get Employee role By ID
export function getEmployeeRoleById(staffId:any) {
  const merchantId = Store.getState()?.auth?.credentials?.merchantId;
  const reqPayload = {merchantId:merchantId,staffId:staffId}
  const data = encryptJson(reqPayload);

  return API({
    method: 'post',
    url: `/merchants/staff/permissions`,
    data:{data},
  })
}

export function getEmployeePermissionAndRoleById(staffId: any) {
  const merchantId = Store.getState()?.auth?.credentials?.merchantId;
  const reqPayload = { merchantId: merchantId, staffId: staffId }
  const data = encryptJson(reqPayload);

  return API({
    method: 'post',
    url: `/merchants/staff-reports/permissions`,
    data: { data },
  })
}

//Remove Employee
export function removeEmployee(currentStaffId: any, staffToDeleteId: any) {
  const reqPayload = {staffId: currentStaffId, staffToDeleteId: staffToDeleteId}
  const data = encryptJson(reqPayload);
  return API({
    method: "delete",
    url: `/merchants/staffs/remove`,
    data: {data},
  })
}

export function manageUserAccess(details:any) {
  return API({
    method: "put",
    url: "/merchants/manage/userAccess",
    data: details,
  })
}

export function updatePIN(details:any) {
  return API({
    method: "put",
    url: `/staff?id=${details.id}&devicePin=${details.pin}`,
  })
}

//Roles and Functions
export const rolesAndFunctions = () => {
  return API ({
    method: 'get',
    url: `/api-info`,
  })
}

//Block or Unblock employee
export const employeeStatus = (currentStaffId: any, {staffId, isToBlock}:any) => {
  const reqPayload = {staffId: currentStaffId, Id: staffId, isToBlock: isToBlock}
  const data = encryptJson(reqPayload);

  return API ({
    method: 'patch',
    url:`/merchants/staffs/status`,
    data:{data},
  })
}

//Edit Employee
export const editEmployee = (details:any) => {
  const staffId = Store.getState()?.auth?.credentials?.id;
  // Filter out null and empty string values from the request payload
  const filteredDetails = filterNullAndEmptyStrings(details);
  const data = encryptJsonWithStaffId(filteredDetails, staffId);

  return API ({
    method: 'put',
    url:`/merchants/staffs/update`,
    data:{data},
  })
}

//Pin Refresh
export const refreshPinApi = (merchantId:any) => {
  return API ({
    method: 'get',
    url:`/merchants/${merchantId}/device-pin`,
  })
}